import { render, staticRenderFns } from "./AddItemForm.vue?vue&type=template&id=7aafe69f&scoped=true&"
import script from "./AddItemForm.vue?vue&type=script&lang=js&"
export * from "./AddItemForm.vue?vue&type=script&lang=js&"
import style0 from "./AddItemForm.vue?vue&type=style&index=0&id=7aafe69f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aafe69f",
  null
  
)

export default component.exports